<template>
  <div class="feedback-manager-container">
    <div class="zhanwei4"></div>

    <!-- 顶部状态栏与统计引导 -->
    <div class="feedback-header-panel">
      <div class="header-left">
        <h2 class="module-title">用户问卷与意见反馈管理</h2>
        <span class="module-desc"
          >查看玩家在游玩或研学过程中提交的建议、体验评价与异常反馈，支持邮件即时答复</span
        >
      </div>
      <div class="header-stats">
        <span class="stat-pill">反馈记录共 {{ total }} 条</span>
      </div>
    </div>

    <!-- 主表格卡片 -->
    <div class="feedback-main-card">
      <el-table
        :data="tableData"
        class="custom-feedback-table"
        v-loading="loadingTable"
        style="width: 100%"
      >
        <el-table-column
          label="编号"
          prop="feedbackId"
          width="90"
          align="center"
        >
          <template #default="{ row }">
            <span class="id-tag">#{{ row.feedbackId }}</span>
          </template>
        </el-table-column>

        <el-table-column label="反馈主题" prop="feedbackTitle" min-width="150">
          <template #default="{ row }">
            <span class="title-txt">{{
              row.feedbackTitle || "用户体验反馈"
            }}</span>
          </template>
        </el-table-column>

        <el-table-column
          label="反馈详情"
          prop="feedbackDesc"
          min-width="220"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <span class="desc-txt">{{ row.feedbackDesc || "无详细描述" }}</span>
          </template>
        </el-table-column>

        <el-table-column label="联系方式" min-width="180">
          <template #default="{ row }">
            <div class="contact-cell">
              <span class="email" v-if="row.feedbackEmail">
                <el-icon><Message /></el-icon>
                {{ row.feedbackEmail }}
              </span>
              <span
                class="phone"
                v-if="row.feedbackIphone || row.feedbackPhone"
              >
                <el-icon><Iphone /></el-icon>
                {{ row.feedbackIphone || row.feedbackPhone }}
              </span>
              <span
                class="empty-txt"
                v-if="
                  !row.feedbackEmail &&
                  !row.feedbackIphone &&
                  !row.feedbackPhone
                "
                >-</span
              >
            </div>
          </template>
        </el-table-column>

        <el-table-column
          label="处理结果"
          prop="feedbackResult"
          min-width="180"
          show-overflow-tooltip
        >
          <template #default="{ row }">
            <span :class="row.feedbackResult ? 'result-txt' : 'empty-txt'">
              {{ row.feedbackResult || "暂未回复" }}
            </span>
          </template>
        </el-table-column>

        <el-table-column label="状态" width="110" align="center">
          <template #default="{ row }">
            <el-tag
              :type="row.feedbackStatus == 0 ? 'warning' : 'success'"
              effect="light"
              round
            >
              {{ row.feedbackStatus == 0 ? "待处理" : "已答复" }}
            </el-tag>
          </template>
        </el-table-column>

        <el-table-column
          label="提交时间"
          prop="createTime"
          width="170"
          align="center"
        />

        <el-table-column label="操作" width="120" align="right" fixed="right">
          <template #default="{ row }">
            <el-button
              :type="row.feedbackStatus == 0 ? 'primary' : 'default'"
              size="small"
              class="action-btn"
              @click="handleEdit(row)"
            >
              {{ row.feedbackStatus == 0 ? "处理回复" : "查看详情" }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 底部分页 -->
      <div class="pagination-bar">
        <el-pagination
          background
          layout="total, prev, pager, next"
          :current-page="currentPage"
          :page-size="10"
          :total="total"
          @current-change="handleCurrentChange"
        />
      </div>
    </div>

    <!-- ================= 回复 / 详情弹窗 ================= -->
    <el-dialog
      v-model="dialogVisible"
      :title="isReadonly ? '反馈详情与处理记录' : '处理用户反馈与答复'"
      width="640px"
      class="custom-feedback-dialog"
      destroy-on-close
      align-center
    >
      <div class="dialog-body-wrap">
        <!-- 用户反馈原件展示 -->
        <div class="feedback-meta-block">
          <div class="meta-row">
            <span class="meta-label">反馈主题:</span>
            <span class="meta-val font-bold">{{
              form.feedbackTitle || "无标题"
            }}</span>
          </div>
          <div class="meta-row">
            <span class="meta-label">用户邮箱:</span>
            <span class="meta-val highlight">{{
              form.feedbackEmail || "未留下邮箱"
            }}</span>
          </div>
          <div
            class="meta-row"
            v-if="form.feedbackIphone || form.feedbackPhone"
          >
            <span class="meta-label">手机号码:</span>
            <span class="meta-val">{{
              form.feedbackIphone || form.feedbackPhone
            }}</span>
          </div>
          <div class="meta-row">
            <span class="meta-label">提交时间:</span>
            <span class="meta-val">{{ form.createTime || "-" }}</span>
          </div>

          <div class="user-content-box">
            <span class="box-title">用户原始反馈内容：</span>
            <p class="user-desc-text">
              {{ form.feedbackDesc || "无详细描述内容" }}
            </p>
          </div>
        </div>

        <!-- 管理员回复输入区 -->
        <div class="reply-input-section">
          <div class="reply-title-row">
            <span class="section-indicator"></span>
            <span class="section-title">{{
              isReadonly ? "系统答复记录" : "编辑答复邮件内容"
            }}</span>
          </div>

          <el-input
            v-model="form.feedbackResult"
            :rows="5"
            type="textarea"
            :placeholder="
              isReadonly
                ? '暂无回复内容'
                : '请输入对用户的回复说明，提交后将自动发送邮件通知对方...'
            "
            maxlength="400"
            show-word-limit
            :readonly="isReadonly"
            class="reply-textarea"
          />

          <span class="reply-tip" v-if="!isReadonly">
            * 提交后将直接调用邮件系统向
            <strong>{{ form.feedbackEmail || "用户邮箱" }}</strong>
            发送本条答复。
          </span>
        </div>
      </div>

      <template #footer>
        <div class="dialog-footer-actions">
          <el-button @click="dialogVisible = false">{{
            isReadonly ? "关闭" : "取消"
          }}</el-button>
          <el-button
            v-if="!isReadonly"
            type="primary"
            class="submit-reply-btn"
            :loading="submitting"
            @click="submitReply"
          >
            发送回复并归档
          </el-button>
        </div>
      </template>
    </el-dialog>

    <div class="zhanwei3"></div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { ElMessage } from "element-plus";
import { Message, Iphone } from "@element-plus/icons-vue";

export default defineComponent({
  name: "FeedbackManager",
  components: {
    Message,
    Iphone,
  },
  data() {
    return {
      currentPage: 1,
      total: 0,
      loadingTable: false,
      submitting: false,
      dialogVisible: false,
      tableData: [] as any[],
      form: {
        createTime: "",
        feedbackDesc: "",
        feedbackEmail: "",
        feedbackId: "",
        feedbackIphone: "",
        feedbackPhone: "",
        feedbackTitle: "",
        feedbackResult: "",
        feedbackStatus: 0,
        gameId: "",
      },
    };
  },
  computed: {
    isReadonly(): boolean {
      return Number(this.form.feedbackStatus) === 1;
    },
  },
  created() {
    this.fetchFeedbackList(this.currentPage);
  },
  methods: {
    fetchFeedbackList(pageNum = 1) {
      this.loadingTable = true;
      const pageSize = 10;
      this.$store
        .dispatch("user/getFeedbackList", { pageNum, pageSize })
        .then((res: any) => {
          this.tableData = res?.records || [];
          this.total = res?.total || 0;
        })
        .catch((err: any) => {
          ElMessage.error(typeof err === "string" ? err : "获取反馈列表失败");
        })
        .finally(() => {
          this.loadingTable = false;
        });
    },

    handleCurrentChange(val: number) {
      this.currentPage = val;
      this.fetchFeedbackList(val);
    },

    handleEdit(row: any) {
      this.form = { ...row };
      this.dialogVisible = true;
    },

    submitReply() {
      if (!this.form.feedbackResult || !this.form.feedbackResult.trim()) {
        ElMessage.warning("请输入回复内容后再提交");
        return;
      }

      this.submitting = true;
      const params = {
        id: this.form.feedbackId,
        email: this.form.feedbackEmail,
        content: this.form.feedbackResult.trim(),
        question: this.form.feedbackTitle || "出发吧意见反馈",
      };

      this.$store
        .dispatch("user/replyFeedback", params)
        .then(() => {
          ElMessage.success("回复邮件发送成功，该条反馈已标记为已处理");
          this.dialogVisible = false;
          this.fetchFeedbackList(this.currentPage);
        })
        .catch((err: any) => {
          ElMessage.error(
            typeof err === "string" ? err : "反馈回复失败，请稍后重试"
          );
        })
        .finally(() => {
          this.submitting = false;
        });
    },
  },
});
</script>

<style lang="less" scoped>
@primary-color: #5d5fef;
@primary-hover: #4b4de0;
@primary-light: #f0f2ff;
@text-main: #0f172a;
@text-sub: #475569;
@text-muted: #94a3b8;
@border-color: #e2e8f0;
@card-border: #f1f5f9;
@success-color: #10b981;
@warning-color: #f59e0b;

.zhanwei4 {
  height: 20px;
}
.zhanwei3 {
  height: 32px;
}

.feedback-manager-container {
  width: 100%;
  max-width: 1240px;
  margin: 0 auto;
  padding: 0 20px;
  box-sizing: border-box;
}

// 顶部信息栏
.feedback-header-panel {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .header-left {
    .module-title {
      font-size: 18px;
      font-weight: 700;
      color: @text-main;
      margin: 0 0 4px 0;
    }
    .module-desc {
      font-size: 12.5px;
      color: @text-muted;
    }
  }

  .header-stats {
    .stat-pill {
      font-size: 12px;
      font-weight: 600;
      color: @primary-color;
      background: @primary-light;
      padding: 4px 12px;
      border-radius: 20px;
    }
  }
}

// 主白底卡片
.feedback-main-card {
  background: #ffffff;
  border-radius: 14px;
  border: 1px solid @card-border;
  box-shadow: 0 4px 18px rgba(15, 23, 42, 0.03);
  padding: 20px 24px 28px;
}

// 表格重塑
.custom-feedback-table {
  .id-tag {
    font-family: monospace;
    font-weight: 600;
    color: @text-muted;
  }

  .title-txt {
    font-weight: 700;
    color: @text-main;
    font-size: 13.5px;
  }

  .desc-txt {
    color: @text-sub;
    font-size: 13px;
  }

  .contact-cell {
    display: flex;
    flex-direction: column;
    gap: 4px;
    font-size: 12px;

    .email,
    .phone {
      display: inline-flex;
      align-items: center;
      gap: 5px;
      color: @text-sub;

      .el-icon {
        font-size: 13px;
        color: @text-muted;
      }
    }
  }

  .result-txt {
    color: #059669;
    font-size: 12.5px;
  }

  .empty-txt {
    color: @text-muted;
    font-size: 12px;
  }

  .action-btn {
    border-radius: 6px;
    font-weight: 600;

    &.el-button--primary {
      background-color: @primary-color;
      border-color: @primary-color;

      &:hover {
        background-color: @primary-hover;
        border-color: @primary-hover;
      }
    }
  }
}

.pagination-bar {
  margin-top: 24px;
  display: flex;
  justify-content: flex-end;
}

// 回复弹窗
.custom-feedback-dialog {
  :deep(.el-dialog__header) {
    border-bottom: 1px solid @border-color;
    margin: 0;
    padding: 16px 24px;

    .el-dialog__title {
      font-size: 16px;
      font-weight: 700;
      color: @text-main;
    }
  }

  .dialog-body-wrap {
    display: flex;
    flex-direction: column;
    gap: 18px;
    padding: 10px 0;

    .feedback-meta-block {
      background: #f8fafc;
      border: 1px solid @border-color;
      border-radius: 10px;
      padding: 16px 18px;
      display: flex;
      flex-direction: column;
      gap: 8px;

      .meta-row {
        display: flex;
        font-size: 13px;

        .meta-label {
          width: 76px;
          color: @text-muted;
          flex-shrink: 0;
        }

        .meta-val {
          color: @text-main;

          &.font-bold {
            font-weight: 700;
          }

          &.highlight {
            color: @primary-color;
            font-weight: 600;
          }
        }
      }

      .user-content-box {
        margin-top: 8px;
        padding-top: 10px;
        border-top: 1px dashed @border-color;

        .box-title {
          display: block;
          font-size: 12px;
          font-weight: 600;
          color: @text-muted;
          margin-bottom: 6px;
        }

        .user-desc-text {
          margin: 0;
          font-size: 13px;
          color: @text-main;
          line-height: 1.6;
          white-space: pre-wrap;
          word-break: break-all;
        }
      }
    }

    .reply-input-section {
      display: flex;
      flex-direction: column;
      gap: 10px;

      .reply-title-row {
        display: flex;
        align-items: center;
        gap: 8px;

        .section-indicator {
          width: 3.5px;
          height: 14px;
          background: @primary-color;
          border-radius: 2px;
        }

        .section-title {
          font-size: 13.5px;
          font-weight: 700;
          color: @text-main;
        }
      }

      .reply-textarea {
        :deep(.el-textarea__inner) {
          border-radius: 8px;
          font-size: 13px;
          line-height: 1.6;

          &:focus {
            box-shadow: 0 0 0 1px @primary-color inset;
          }
        }
      }

      .reply-tip {
        font-size: 12px;
        color: @text-muted;
        line-height: 1.5;

        strong {
          color: @text-main;
        }
      }
    }
  }

  .dialog-footer-actions {
    display: flex;
    justify-content: flex-end;
    gap: 10px;

    .submit-reply-btn {
      background-color: @primary-color;
      border-color: @primary-color;
      font-weight: 600;

      &:hover {
        background-color: @primary-hover;
        border-color: @primary-hover;
      }
    }
  }
}
</style>
